import { AssistChip, Stack, Text } from '@sixui/ui';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import type { ITableRowProps } from '~/components/molecules/Table';
import type { IPoll } from '~/lib/api/modules/Polls';
import { RelativeTime } from '~/components/atoms/RelativeTime';
import { Table } from '~/components/molecules/Table';
import { getPollInfo } from './getPollInfo';
import { PollListItemMenu } from './PollListItemMenu';

export type IPollListItemProps = ITableRowProps & {
  poll: IPoll;
};

export const PollListItem: React.FC<IPollListItemProps> = (props) => {
  const { poll, ...other } = props;
  const { t, i18n } = useTranslation();

  const actionUrl = `/apps/${poll.appId}/polls/${poll._id}`;
  const locale = i18n.language;
  const pollInfo = getPollInfo(poll);
  const start = pollInfo.startAt
    ? pollInfo.startAt.toLocaleString(DateTime.DATE_MED, { locale })
    : undefined;
  const end = pollInfo.endAt
    ? pollInfo.endAt.toLocaleString(DateTime.DATE_MED, { locale })
    : undefined;

  return (
    <Table.Row {...other}>
      <Stack as={Table.BodyAction} horizontal gap={3} href={actionUrl}>
        <Stack gap={1}>
          {(poll.title || start || end) && (
            <Stack>
              {poll.title && (
                <Text variant="label" size="lg">
                  {poll.title}
                </Text>
              )}

              {(start || end) && (
                <Text variant="body" size="md">
                  {start && end
                    ? t('common.dateRange', { start, end })
                    : start
                      ? t('common.fromDate', { start })
                      : end
                        ? t('common.untilDate', { end })
                        : undefined}
                </Text>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      <Stack as={Table.Body} gap={1}>
        <div>
          <AssistChip label={t(`PollInfo.${pollInfo.status}`)} />
        </div>
        {pollInfo.programmedAt && (
          <Text variant="body" size="sm" dimmed>
            <RelativeTime date={pollInfo.programmedAt} />
          </Text>
        )}
      </Stack>

      <Stack as={Table.Body} horizontal justify="end">
        <PollListItemMenu poll={poll} />
      </Stack>
    </Table.Row>
  );
};
